export default "__VITE_ASSET__Q2eItERN__"